import axios from "axios";

const getTableData = async (url) => {
  const result = { status: false, data: { total: 0, rows: [] } };
  await axios
    .get(url)
    .then((res) => {
      result.status = true;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error loading Data", error.message, error);
    });

  return result;
};

const createTag = async (taskgroupId, data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/taggroup/${taskgroupId}/tag`, data)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const updateTag = async (tag_id, data) => {
  const result = { status: false, data: [] };

  await axios
    .put(`/api/backend/tag/${tag_id}`, data)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const deleteTag = async (tag_id) => {
  const result = { status: false, data: [] };

  await axios
    .delete(`/api/backend/tag/${tag_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getTag = async (tag_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/tag/${tag_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

// -------------

const createTaggroup = async (data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/taggroup`, data)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const updateTaggroup = async (taggroup_id, data) => {
  const result = { status: false, data: [] };

  await axios
    .put(`/api/backend/taggroup/${taggroup_id}`, data)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const deleteTaggroup = async (taggroup_id) => {
  const result = { status: false, data: [] };

  await axios
    .delete(`/api/backend/taggroup/${taggroup_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getTaggroup = async (taggroup_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/taggroup/${taggroup_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

// ----------
const getAllSwipe = async () => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipes/map`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getSwipe = async (swipe_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipe/${swipe_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const createSwipe = async (data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipe`, data)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const updateSwipe = async (swipe_id, data) => {
  const result = { status: false, data: [] };

  await axios
    .put(`/api/backend/swipe/${swipe_id}`, data)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const deleteSwipe = async (swipe_id) => {
  const result = { status: false, data: [] };

  await axios
    .delete(`/api/backend/swipe/${swipe_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const checkedSwipe = async (swipe_id) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipe/${swipe_id}/checked`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const loadSwipeTripadvisor = async (swipe_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipe/${swipe_id}/tripadvisor`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

// ----------

const getSwipetypes = async (taggroup_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipetypes`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

// ----------

const getTagsOfSwipetype = async (swipetype_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/taggroups/${swipetype_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data.items;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const login = async (username, password) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/user/login`, { email: username, password })
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const logout = async () => {
  const result = { status: true, data: [] };

  await axios.post(`/api/backend/user/logout`);

  return result;
};

const refreshToken = async () => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/user/refresh`)
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const uploadSwipeImage = async (swipe_id, formData) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipe/${swipe_id}/images`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const uploadSwipeVideo = async (swipe_id, formData) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipe/${swipe_id}/video`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getSwipeImages = async (swipe_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipe/${swipe_id}/images`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getSwipeVideos = async (swipe_id) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipe/${swipe_id}/videos`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getAllSwipeImages = async () => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/media`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};
const deleteMedia = async (media_id) => {
  const result = { status: false, data: [] };

  await axios
    .delete(`/api/backend/media/${media_id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const cropMedia = async (media_id, data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/media/${media_id}/crop`, data)
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getSwipeCheckData = async (data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipes/check`, data)
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getSwipeCheckDataBusinessHours = async (data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipes/check/businesshours`, data)
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getSwipeCheckDataTAImages = async (data) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipes/check/taimages`, data)
    .then((res) => {
      console.log("res", res.data);
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const rejectSwipeCheck = async (swipe_id, reason) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipes/check/reject`, { swipe_id, reason })
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getTripadvisorItems = async (
  latitude,
  longitude,
  city,
  postcode,
  name,
) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/service/tripadvisor`, {
      params: {
        latitude,
        longitude,
        city,
        postcode,
        name,
      },
    })
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getKpi = async (kpiType, startDate, endDate) => {
  const result = { status: false, data: null };

  await axios
    .get(
      `/api/backend/kpi/${encodeURIComponent(kpiType)}/${encodeURIComponent(
        startDate,
      )}/${encodeURIComponent(endDate)}`,
    )
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const importOSMSwipes = async (content) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/swipes/import/osm`, JSON.parse(content))
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const getMapSwipes = async (filter) => {
  const result = { status: false, data: [] };

  await axios
    .get(`/api/backend/swipes/map`, {
      params: {
        filter,
      },
    })
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const setSuggestChangesAsDone = async (id) => {
  const result = { status: false, data: [] };

  await axios
    .post(`/api/backend/suggestchange/${id}`)
    .then((res) => {
      result.status = res.data.status;
      result.data = res.data?.data;
    })
    .catch((error) => {
      console.log("Error", error.message, error);
    });

  return result;
};

const API = {
  getSwipeCheckData,
  login,
  logout,
  refreshToken,
  getSwipe,
  getAllSwipe,
  getMapSwipes,
  createSwipe,
  updateSwipe,
  deleteSwipe,
  getSwipetypes,
  getTableData,
  createTag,
  getTag,
  updateTag,
  deleteTag,
  createTaggroup,
  getTaggroup,
  updateTaggroup,
  deleteTaggroup,
  getTagsOfSwipetype,
  checkedSwipe,
  uploadSwipeImage,
  uploadSwipeVideo,
  getSwipeImages,
  getSwipeVideos,
  deleteMedia,
  getAllSwipeImages,
  cropMedia,
  loadSwipeTripadvisor,
  getTripadvisorItems,
  getSwipeCheckDataBusinessHours,
  getSwipeCheckDataTAImages,
  rejectSwipeCheck,
  getKpi,
  importOSMSwipes,
  setSuggestChangesAsDone,
};

export default API;
